import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, FormControl } from 'react-bootstrap';
import Empty from '../../components/Empty.jsx';
import {
  loadingContent,
  noResultsContent,
} from '../../components/EmptyStates.jsx';
import OrganizationHeader from '../../components/headers/PageHeaders/Organization/OrganizationHeader.jsx';
import { PlusButtonIcon } from '../../components/icons/PlusButtonIcon.jsx';
import { NewUserLink } from '../../components/links/index.jsx';
import UsersTable from '../../components/organizations/Users/UsersTable.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import { mapFinalFormErrors } from '../../lib/utils.js';
import {
  selectUser as selectCurrentUser,
  selectUserPermissions,
  selectUserRestrictions,
  signOut,
} from '../../modules/auth.js';
import {
  deleteUser,
  retrieveUsers,
  searchUsers,
  selectSearchUsersResults,
  selectSearchUsersState,
  updateSearchQuery,
} from '../../modules/users.js';

const mapStateToProps = (state) => ({
  searchResults: selectSearchUsersResults(state),
  searchSuccess: selectSearchUsersState(state).success,
  currentUser: selectCurrentUser(state),
  permissions: selectUserPermissions(state),
  restrictions: selectUserRestrictions(state),
});

const mapDispatchToProps = {
  retrieveUsers,
  searchUsers,
  updateSearchQuery,
  deleteUser,
  signOut,
};

const mapErrors = mapFinalFormErrors('Failed to save');

const UsersContainer = ({
  slug,
  searchUsers,
  updateSearchQuery,
  searchResults,
  searchSuccess,
  currentUser,
  deleteUser,
  signOut,
  permissions,
  restrictions,
}) => {
  const [isFirstLoading, setIsFirstLoading] = useState(true);
  const active = searchResults.filter((user) => user.status === 'active');
  const administrators = searchResults.filter(
    (user) => user.orgRole === 'admin'
  );

  const handleSearch = (event) => {
    const query = event.target.value;
    updateSearchQuery(query);
    searchUsers(query);
  };

  const onDelete = (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      const submitPromise = deleteUser(userId);

      submitPromise.then(() => searchUsers()).catch(mapErrors);
    }
  };

  const sortByASC = (arr) =>
    arr.sort((a, b) =>
      a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1
    );

  const renderTable = () => {
    if (isFirstLoading || !searchSuccess)
      return <Empty simplified content={loadingContent} />;
    if (searchSuccess && !searchResults.length)
      return <Empty simplified content={noResultsContent} />;

    return (
      <UsersTable
        slug={slug}
        users={sortByASC(searchResults)}
        currentUserId={currentUser.id}
        currentUserRole={currentUser.orgRole}
        onDelete={onDelete}
        onSignOut={signOut}
        permissions={permissions}
        restrictions={restrictions}
      />
    );
  };

  useEffect(() => {
    searchUsers().then(() => setIsFirstLoading(false));
  }, []);

  return (
    <React.Fragment>
      <OrganizationHeader slug={slug} organizationTabs />

      <SubHeader flexJustify small>
        <div className="flex">
          <h2>Users</h2>
          <strong className="header-item bordered text-muted">
            Total:&nbsp;
            <span className="text-primary">{searchResults.length}</span>
          </strong>
          <strong className="header-item bordered text-muted">
            Active:&nbsp;
            <span className="text-primary">{active.length}</span>
          </strong>
          <strong className="header-item bordered text-muted">
            Administrators:&nbsp;
            <span className="text-primary">{administrators.length}</span>
          </strong>
        </div>

        <div className="flex flex-end" style={{ width: '50%' }}>
          <div
            className="m-r-16 m-l-12"
            style={{ width: '100%', maxWidth: '540px' }}
          >
            <FormControl
              placeholder="Search"
              type="text"
              onChange={handleSearch}
            />
          </div>
          <NewUserLink>
            <Button bsStyle="success">
              <PlusButtonIcon />
              Add User
            </Button>
          </NewUserLink>
        </div>
      </SubHeader>
      {renderTable()}
    </React.Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersContainer);
